<template>
  <v-app>
    <nav-bar v-if="$route.name !== 'Login'"/>
    <v-content class="blue">
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar'
export default {
  components:  { NavBar },
  data () {
    return {}
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue